'use strict';

module.exports = {
    // grays
    gray: '#bbb',
    lightGray: '#f6f6f6',
    darkGray: '#868e96',
    // light shades
    white: '#FFFFFF',
    snow: '#F9FAFC',
    darkSnow: '#EFF2F7',
    extraDarkSnow: '#E5E9F2',
    // dark tones
    silver: '#8492A6',
    slate: '#3C4858',
    steel: '#273444',
    black: '#1F2D3D',
    // dark shades
    smoke: '#E0E6ED',
    darkSmoke: '#D3DCE6',
    extraDarkSmoke: '#C0CCDA',
    // blue shades
    lightBlue: '#00B9F7',
    blue: '#009EEB',
    darkBlue: '#337AB7',
    // orange shades
    lightOrange: '#FF9E7C',
    orange: '#FF7849',
    darkOrange: '#FF5216',
    // green shades
    lightGreen: '#29EB7F',
    green: '#13CE66',
    darkGreen: '#0F9F4F',
    // yellow shades
    lightYellow: '#FFD55F',
    yellow: '#FFC82C',
    darkYellow: '#F8B700',
    // ui colors
    info: '#1FB6FF',
    success: '#13CE66',
    danger: '#FF4949',
    warning: '#FFC82C'
};


//////////////////
// WEBPACK FOOTER
// ../component-library/build/styles/colors.js
// module id = 155
// module chunks = 0